<template>
  <div>
    <ConfigListItem
      :label="dgLabel"
      :value="strValue"
      :date="maxUpdatedAt"
      :login="maxUpdatedBy"
      @click="openEditDialog"
    />

    <ODialog ref="dialog" :max-width="800">
      <v-card>
        <ODialogBar :title="`Origem do ${dgLabel}`" @close="dismiss" />
        <v-card-text class="pa-6">
          <div class="d-flex">
            <OVerticalTabs
              class="mr-6"
              v-model="clonedValues.source"
              :tabs="[
                { value: 'sensor', text: 'Valor simples' },
                { value: 'can', text: 'CAN' }
              ]"
            />

            <v-tabs-items class="flex-grow-1" v-model="clonedValues.source">
              <div class="px-4" v-if="clonedValues.source == null">
                Escolha um valor da lista ao lado.
              </div>

              <v-tab-item value="sensor" class="pa-4">
                <v-select
                  placeholder="Selecione..."
                  v-model="clonedValues.value"
                  :items="opts"
                  item-text="label"
                />
              </v-tab-item>

              <v-tab-item value="can" class="pa-4">
                <SelectCANVariable
                  :canDictId="canDictId"
                  v-model="clonedValues.canVariable"
                />
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-card-text>
        <v-card-text class="pa-6" style="border-top: 1px solid #ccc">
          <OSelect
            class="w-400"
            label="Label no gráfico"
            placeholder="Selecione..."
            v-model="clonedValues.label"
            :items="labelOpts"
            item-text="label"
            clearable
          />
        </v-card-text>
        <ODialogButtons
          class="pa-6"
          txtApply="Salvar"
          @cancel="dismiss"
          @apply="save"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import ConfigListItem from './ConfigListItem.vue'
import { mostRecentlyUpdated, getCfg } from './config-utils.js'
import VehicleCfgs from 'vehicle-cfgs'
import OVerticalTabs from './OVerticalTabs.vue'
import SelectCANVariable from './SelectCANVariable.vue'

// usado aqui e na tela de cópia de configs
export function displayValue(allConfigs, dgNumber) {
  let X = dgNumber
  let cfgs = {
    source: getCfg(allConfigs, `dg${X}source`),
    value: getCfg(allConfigs, `dg-${X}-ativa-em-bateria`),
    canDict: getCfg(allConfigs, `canDict`),
    canVariable: getCfg(allConfigs, `dg${X}CanVariable`)
  }

  let suffix = getCfg(allConfigs, `dg${X}label`)
  suffix = suffix == null ? '' : ` (${suffix})`

  switch (cfgs.source) {
    case 'sensor': {
      let optValue = cfgs.value
      if (optValue == '0x00') return 'AtivaBateria=0' + suffix
      if (optValue == '0x01') return 'AtivaBateria=1' + suffix
      return '???'
    }
    case 'can': {
      let y = cfgs.canVariable
      return `CAN variable=${y && y.code}` + suffix
    }
    default:
      return '??'
  }
}

export function copyValue(allConfigs, dgNumber) {
  let X = dgNumber
  let props = [
    `dg${X}source`,
    `dg-${X}-ativa-em-bateria`,
    `dg${X}label`,
    `dg${X}CanVariable`
  ]

  let result = {}
  for (let p of props) result[p] = getCfg(allConfigs, p)
  return result
}

export default {
  components: { ConfigListItem, OVerticalTabs, SelectCANVariable },
  props: {
    allConfigs: { required: true },
    configDef: { required: true }
  },
  data() {
    let X = this.configDef.dgNumber
    return {
      clonedValues: {},
      opts: VehicleCfgs.get(`dg-${X}-ativa-em-bateria`, 'opts'),
      labelOpts: VehicleCfgs.get(`dg${X}label`, 'opts')
    }
  },
  computed: {
    canDictId() {
      return getCfg(this.allConfigs, 'canDictId')
    },
    dgLabel() {
      return `DG` + this.dgNumber
    },
    dgNumber() {
      return this.configDef.dgNumber
    },
    strValue() {
      return displayValue(this.allConfigs, this.dgNumber)
    },
    mostRecent() {
      let X = this.dgNumber
      return mostRecentlyUpdated(
        this.allConfigs,
        `dg${X}source`,
        `dg-${X}-ativa-em-bateria`,
        `dg${X}label`,
        `dg${X}CanVariable`
      )
    },
    maxUpdatedAt() {
      return this.mostRecent && this.mostRecent.updatedAt
    },
    maxUpdatedBy() {
      return this.mostRecent && this.mostRecent.updatedBy
    }
  },
  methods: {
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    openEditDialog() {
      let X = this.dgNumber
      this.clonedValues = {
        source: getCfg(this.allConfigs, `dg${X}source`),
        value: getCfg(this.allConfigs, `dg-${X}-ativa-em-bateria`),
        label: getCfg(this.allConfigs, `dg${X}label`),
        canDict: getCfg(this.allConfigs, `canDict`),
        canVariable: getCfg(this.allConfigs, `dg${X}CanVariable`)
      }

      return this.$refs.dialog.$open()
    },
    async save() {
      let payload = {}
      let X = this.dgNumber
      payload[`dg${X}source`] = this.clonedValues.source
      payload[`dg-${X}-ativa-em-bateria`] = this.clonedValues.value
      payload[`dg${X}label`] = this.clonedValues.label
      payload[`dg${X}CanVariable`] = this.clonedValues.canVariable
      this.$emit('save', payload)
      this.dismiss()
    }
  }
}
</script>

<style></style>
